import { styled } from '@clickcease/cc-client-components-lib'

export const OutsideLink = styled('a', {
  fontWeight: '$r',
  fontSize: '$md',
  lineHeight: 1.2,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  color: '$primaryColor',
  cursor: 'pointer',

  '&:hover': {
    color: '$buttonHovered',
  },
})
